import { Component, Prop, h } from '@stencil/core';
/**
 * Shortcut link to the notifications manager. Displays number of unread messages.
 */
@Component({
  tag: 'notification-shortcut',
  styleUrl: 'notification-shortcut.css',
  shadow: true,
})
export class NotificationShortcut {
  /**
   * The count of unread messages
   */
  @Prop() unreadCount: number;

  /**
   * The url to the notifications manager page
   */
  @Prop() targetUrl: string;

  render() {
    return (
      <a href={this.targetUrl}>
        <button>
          <span>{this.unreadCount}</span>
          <img src={`/Bell.svg`}></img>
        </button>
      </a>
    );
  }
}
